import { Title } from "../../Utils/UI/Text";
import { Layout } from "antd";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { carbonCreditsData, totalCount, getCarbonCredits } from "../../CarbonCredits/Application/CarbonCredits.business";
import {
  getCarbonCreditsSelector,
  getCarbonCreditsCountSelector,
} from "../Infrastructure/CarbonCredits.reducer.js";
import NftsBoard from "../../NFTS/UI/NftsBoard";

const { Content } = Layout;

const CarbonCredits = () => {
  const carbonCreditsData = useSelector(getCarbonCreditsSelector);
  const totalCount = useSelector(getCarbonCreditsCountSelector);
  useEffect(() => {
    getCarbonCredits();
  }, []);

  return (
    <Content >
      <Title children="Créditos de Carbono" />

      <NftsBoard
        nftsData={carbonCreditsData}
        getNfts={getCarbonCredits}
        totalCount={totalCount}
      />
    </Content>
  );
};

export default CarbonCredits;

